import React from 'react';
import { Link } from 'react-router-dom';
import { superAdminTooltips } from '../../../../shared/config/actionHelpCatalog';
import HelpTooltipTrigger from '../../../../shared/ui/common/HelpTooltipTrigger';
import { getDocumentStatePresentation } from '../../lib/legalDocumentPresentation';
import { useSuperAdminStore } from '../../store/useSuperAdminStore';
import { StatusPill } from '../components';

interface CompanyLegalSummaryProps {
  companyId: number;
}

const CompanyLegalSummary: React.FC<CompanyLegalSummaryProps> = ({ companyId }) => {
  const summary = useSuperAdminStore((state) => state.companyLegalSummary);
  const loading = useSuperAdminStore((state) => state.companyLegalSummaryLoading);
  const error = useSuperAdminStore((state) => state.companyLegalSummaryError);
  const load = useSuperAdminStore((state) => state.loadCompanyLegalSummary);
  const clear = useSuperAdminStore((state) => state.clearCompanyLegalSummary);
  React.useEffect(() => {
    void load(companyId).catch(() => undefined);
    return clear;
  }, [clear, companyId, load]);
  const active = summary?.companyId === companyId ? summary : null;
  const latest = active?.packages[0] ?? null;
  const state = latest ? getDocumentStatePresentation(latest.state) : null;

  return (
    <section className="admin-company-nested admin-company-legal-summary" aria-label="Legal profile and document packages">
      <div className="admin-company-nested__header"><div><h3>Legal profile</h3><p>Summary of retained evidence</p></div><HelpTooltipTrigger label="Legal profile" help={superAdminTooltips.companyLegalSummary} placement="bottom-start" /></div>
      {loading && !active ? <div role="status">Loading legal summary…</div> : error && !active ? <div role="alert">Legal summary is unavailable. Open Documents to retry.</div> : active ? <>
        {active.profile ? <div className="admin-company-legal-summary__row"><strong>{active.profile.data.verifiedAtUtc ? 'Verified legal profile' : 'Unverified legal profile'}</strong><span>{active.profile.data.jurisdiction} · {active.profile.data.locale}</span></div> : <p>No legal profile is available.</p>}
        <div className="admin-company-legal-summary__row"><strong>{active.packages.length} retained package{active.packages.length === 1 ? '' : 's'}</strong>{state && <StatusPill tone={state.tone === 'danger' ? 'critical' : state.tone}><span aria-hidden="true">{state.marker}</span> {state.label}</StatusPill>}</div>
      <Link to={`/super-admin/documents?company=${companyId}${latest ? `&package=${latest.id}` : ''}`}>Open documents workspace</Link>
      </> : <p>No legal profile is available.</p>}
    </section>
  );
};

export default CompanyLegalSummary;
